/***
 * 需要缓存的页面，必须在页面设置 和路由 name 相同的  name
 *
 * {
    name: 'memberManage', // 会员管理
    path: '/memberManage', // 页面 name 必须和此相同
    meta: {
      title: '会员管理',
      keepAlive: true    // 设置为需要缓存
    },
    component: () => import ('@/pages/memberManage/memberManage/memberManage.vue')
  }
 
 */

import Router from './router'

let keepAliveRoute = []
Router.options.routes.forEach((item) => {
  if (item.meta && item.meta.keepAlive) {
    keepAliveRoute.push(item.name)
  }
})

export default keepAliveRoute